import React, { useEffect, useState, useMemo } from 'react';
import './index.css';
import { Navigate, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Menu, Spin, Avatar, Popover, Button, Divider, Tag, Tooltip } from 'antd';
import {
  DatabaseOutlined,
  UsergroupAddOutlined,
  DashboardOutlined,
  CloudServerOutlined,
  UserOutlined,
  LogoutOutlined,
  RightSquareOutlined,
  LeftSquareOutlined,
  BehanceSquareFilled,
  SendOutlined,
  ToolOutlined
} from '@ant-design/icons';
import Dash from '../../views/dash';
import WorkOrder from '../../views/workorder';
import AnRecord from '../../views/anrecord';
import WorkOrderCreate from '../../views/workordercreate';
import WorkOrderDetail from '../../views/workorderdetail';
import Email from '../../views/email';
import UsrManage from '../../views/usrManage';
import BlacklistManage from '../../views/blacklistManage';
import Finance from '../../views/finance';
import RoleManage from '../../views/roleManage';
import Notification from '../../views/notification';
import Exception403 from '../../views/exception';
import UserCenter from '../../views/usercenter';
import Ticket from '../../views/Ticket';
import NotificationBell from '../../components/notificationbell';
import SophiaAssistant from '../../components/sophiaassistant';


import { useAuth } from '../../utils/authentication';
import { trackUserEnterHomePage } from '../../utils/tracker';

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (!loading && isAuthenticated) {
      trackUserEnterHomePage();
    }
  }, [isAuthenticated, loading]);


  // const [userInfo, setUserInfo] = useState(null);
  // useEffect(() => {
  //   try {
  //     const userinfo = JSON.parse(localStorage.getItem('userInfo'));
  //     if (userinfo) {
  //       setUserInfo(userinfo);
  //     }
  //   } catch (error) {
  //     console.log('Error getting user info:', error);
  //   }
  // }, []);

  const [userInfo] = useState(() => {
    try {
        return JSON.parse(
            localStorage.getItem("userInfo")
        );
    } catch {
        return null;
    }
  });
  console.log('userInfo======>', userInfo)



  const baseMenuItems = [
    {
      key: '/dash',
      icon: <DashboardOutlined />,
      label: 'DashBoard',
      element: <Dash />,
    },
    {
      key: '/workorder',
      icon: <DatabaseOutlined />,
      label: 'WorkOrder',
      element: <WorkOrder />
    },
    {
      key: '/anrecord',
      icon: <CloudServerOutlined />,
      label: 'AnRecord',
      element: <AnRecord />
    },
    {
      key: '/blacklistmanage',
      icon: <BehanceSquareFilled />,
      label: 'BlacklistManage',
      element: <BlacklistManage />
    },
    {
      key: '/finance',
      icon: <CloudServerOutlined />,
      label: 'Finance',
      element: <Finance />
    },
    {
      key: '/usrmanage',
      icon: <UserOutlined />,
      label: 'UserManagement',
      element: <UsrManage />
    },
    {
      key: '/rolemanage',
      icon: <UsergroupAddOutlined />,
      label: 'RoleManagement',
      element: <RoleManage />
    },
    {
      key: '/ticket',
      icon: <ToolOutlined />,
      label: 'Ticket',
      element: <Ticket />
    }
    
  ];

  const routeItems = useMemo(() => {
    const flattenMenuItems = (items) => {
      return items.reduce((acc, item) => {
        if (item.children) {
          return [...acc, item, ...flattenMenuItems(item.children)];
        }
        return [...acc, item];
      }, []);
    };

    const allMenuItems = flattenMenuItems(baseMenuItems);
    const role = String(userInfo?.userRole || '').trim().toLowerCase();
    const adminOnlyKeys = [ '/finance', '/usrmanage', '/rolemanage']; // '/dash',
    if (role === 'admin') return allMenuItems;
    return allMenuItems.filter((item) => !adminOnlyKeys.includes(item.key));
  }, [userInfo]);

  const handleMenuClick = (e) => {
    navigate(e.key);
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="home">
      <div className="home-body">
        <div className="home-body-left" style={{ width: collapsed ? 80 : 200 }}>
          <div className={collapsed ? 'home-header-logo' : 'home-header-logo-open'} style={{ width: collapsed ? 40 : 140 }}>
            {collapsed ? (
              <span className="logo-circle">P</span>
            ) : (
              <>
                <span className="logo-circle">P</span>
                <span className="logo-text">PRIME AGENCY</span>
              </>
            )}
          </div>

          <Menu
            mode="inline"
            items={routeItems}
            selectedKeys={[location.pathname]}
            onClick={handleMenuClick}
            inlineCollapsed={collapsed}
            style={{
              width: collapsed ? 60 : 200,
              maxHeight: 280,
              borderRight: '0 solid #f0f0f0',
              background: 'transparent',
            }}
          />

          <div style={{
            marginTop: 'auto',
            width: '100%',
            padding: collapsed ? '12px 12px' : '12px 16px',
          }}>
            <Button
              type="text"
              icon={<SendOutlined />}
              onClick={() => window.open('https://autoload.usprimeagency.cn/', '_blank', 'noopener,noreferrer')}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 14,
                color: '#1f63fb',
              }}
            >
              {!collapsed && 'Open AutoLoad'}
            </Button>

            <NotificationBell collapsed={collapsed} />

            <Popover
              content={
                <div style={{ minWidth: 200 }}>
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: '#8c8c8c' }}>Group</div>
                    <Tag color="#1f63fb">Prime Group</Tag>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: '#8c8c8c' }}>User</div>
                    <Tag color="#1f63fb">{userInfo?.username}</Tag>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: '#8c8c8c' }}>User Role</div>
                    <Tag color="#1f63fb">{userInfo?.userRole}</Tag>
                  </div>

                  <Divider style={{ margin: '10px 0' }} />

                  <div
                    className="header-user-center"
                    onClick={() => navigate('/user-center')}
                    style={{ padding: '0 10px', boxSizing: 'border-box' }}
                  >
                    User Center
                  </div>

                  <Divider style={{ margin: '10px 0' }} />

                  <Button type="link" danger icon={<LogoutOutlined />} style={{ padding: 0 }} onClick={() => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');
                    navigate('/login', { replace: true });
                  }}>
                    Logout
                  </Button>
                </div>
              }
              placement="rightBottom"
              trigger="click"
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: collapsed ? 'center' : 'flex-start',
                cursor: 'pointer',
                padding: '2px 20px',
                borderRadius: '4px',
                transition: 'background-color 0.3s'
              }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <Tooltip title={collapsed ? 'User Settings' : ''} placement="right">
                  <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1f63fb' }} size={'small'} />
                </Tooltip>
                {!collapsed && <span style={{ marginLeft: 12, fontSize: '14px' }}>{userInfo?.username}</span>}
              </div>
            </Popover>

            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 12,
              paddingTop: 12,
              borderTop: '1px solid #f0f0f0'
            }}>
              <Button
                type="text"
                icon={collapsed ? <RightSquareOutlined /> : <LeftSquareOutlined />}
                onClick={() => setCollapsed(!collapsed)}
                style={{ width: '100%', color: '#666666' }}
              >
              </Button>
            </div>
          </div>
        </div>

        <div className="home-body-content">
          <Routes>
            {routeItems.map((item, index) => (
              <Route key={index} path={item.key} element={item.element} />
            ))}
            <Route path="notify" element={<Notification />} />
            <Route path="*" element={<Exception403 />} />
            <Route path="/workorderdetail/:hblNo" element={<WorkOrderDetail />} />
            <Route path="/workordercreate" element={<WorkOrderCreate />} />
            <Route path="/email" element={<Email />} />
            <Route path="/user-center" element={<UserCenter />} />

            <Route
              path="/"
              element={<Navigate to={(routeItems[0]?.key || '/workorder')} replace />}
            />
          </Routes>
        </div>
      </div>

      <SophiaAssistant />
    </div>
  );
}

export default Home;
